import { STATE_NAMES } from "encamp-shared/src/constants/states";
import { SubmissionStatus } from "generated-graphql/graphql";

// Status filter options for multi-select checkbox menu
export const STATUS_FILTER_OPTIONS: Record<SubmissionStatus, string> = {
  [SubmissionStatus.NotStarted]: "🔶 Upcoming",
  [SubmissionStatus.InProgress]: "🚧 In Progress",
  [SubmissionStatus.EncampInitialReview]: "⛺️ In Encamp Review",
  [SubmissionStatus.InReview]: "🔍 In Review",
  [SubmissionStatus.ProcessingSubmission]: "✅ Awaiting Submission",
  [SubmissionStatus.FilingComplete]: "🎉 Submitted",
  [SubmissionStatus.NotReporting]: "⭕️ Not Reporting",
};

// All statuses derived from the filter options object keys
export const ALL_STATUSES = Object.keys(STATUS_FILTER_OPTIONS) as SubmissionStatus[];

// US States list for filtering
export const US_STATES = Object.keys(STATE_NAMES);
